<div [formGroup]="icmsForm">

    <app-ativacao-section-card
        [control]="isAtivoControl"
        titulo="ICMS"
        descricaoAtivo="ICMS ativo. A regra padrão e as exceções abaixo serão aplicadas no cálculo desta natureza de operação."
        descricaoInativo="ICMS inativo. Nenhum valor de ICMS será calculado nesta natureza de operação."
        emptyStateDescricao="Ative o ICMS acima para configurar a regra padrão, as observações e as exceções deste tributo.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ──────────────────────────────────────────────── -->
    <app-icms-tributo-regra-section
        [form]="icmsForm"
        [codigoTributos]="codigoTributos"
        [modalidadesBc]="modalidadesBc"
        [modalidadesBcSt]="modalidadesBcSt"
        [motivosDesoneracao]="motivosDesoneracaoIcms"
        [motivosReducaoAdRem]="motivosReducaoAdRem"
        [cfopLookupUrl]="cfopLookupUrl"
        [personalizadasCount]="personalizadasCount"
        [personalizarDisabled]="formulasParaCst.length === 0"
        cfopControlName="cfopPadrao"
        [tipoOperacao]="tipoOperacaoValue"
        (personalizar)="abrirEditorFormulas()">
    </app-icms-tributo-regra-section>

    <!-- ── Observações ────────────────────────────────────────────────── -->
    <app-icms-tributo-observacoes-section
        [control]="$any(icmsForm.get('observacao'))"
        [variaveis]="icmsForm.get('cstIcms')?.value ? variaveisUnicas : []"
        titulo="Informações complementares"
        icone="notes"
        placeholder="Texto da observação que será impresso no documento fiscal..."
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-icms-tributo-observacoes-section>

    <!-- ── Informações adicionais ao fisco ───────────────────────────────────────── -->
    <app-icms-tributo-observacoes-fisco-section
        [control]="$any(icmsForm.get('observacaoFisco'))"
        [variaveis]="icmsForm.get('cstIcms')?.value ? variaveisUnicas : []"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-icms-tributo-observacoes-fisco-section>

    <!-- ── Exceções ───────────────────────────────────────────────────── -->
    <app-icms-tributo-excecoes-section
        [idNaturezaOperacao]="idNaturezaOperacao"
        [codigoTributos]="codigoTributos"
        [cfopLookupUrl]="cfopLookupUrl"
        [modalidadesBc]="modalidadesBc"
        [modalidadesBcSt]="modalidadesBcSt"
        [motivosDesoneracao]="motivosDesoneracaoIcms"
        [motivosReducaoAdRem]="motivosReducaoAdRem"
        [variaveis]="variaveisUnicas"
        [formulasIcms]="formulasIcms"
        [tipoOperacao]="tipoOperacaoValue"
        [excecoesPendentes]="excecoesPendentes"
        (excecoesChange)="excecoesChange.emit($event)">
    </app-icms-tributo-excecoes-section>

    }

</div>
